import React from 'react';
import './App.css';
import BlockStorageDemo from './BlockStorageDemo';
import ObjectStorageDemo from './ObjectStorageDemo';
import FileStorageDemo from './FileStorageDemo';
import amazonStudiosLogo from './Amazon_Studios_logo2.png';

const awsGreen = '#6cae3e';

function App() {
  return (
    <div className="App" style={{ background: '#181a1b', minHeight: '100vh', color: '#fff' }}>
      <a href="https://aws.amazon.com/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem', marginBottom: '1.5rem' }}>
        <img src={amazonStudiosLogo} alt="Amazon Studios Logo" style={{ maxWidth: '340px', width: '60%', height: 'auto', background: 'transparent' }} />
      </a>
      <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
        <a href="https://aws.amazon.com/compare/the-difference-between-block-file-object-storage/" target="_blank" rel="noopener noreferrer" style={{ color: awsGreen, fontWeight: 'bold', textDecoration: 'underline', fontSize: '1.1rem' }}>
          AWS: The Difference Between Block, File, and Object Storage
        </a>
      </div>
      <div style={{ textAlign: 'center', color: '#ccc', marginBottom: '1.5rem', fontSize: '1.05rem' }}>
        This is a small interactive demo to explain the differences between the three file systems.
      </div>
      <BlockStorageDemo />
      <ObjectStorageDemo />
      <FileStorageDemo />
      {/* Future: Add ObjectStorageDemo and FileStorageDemo here */}
      <footer style={{ textAlign: 'center', margin: '2rem 0', color: '#aaa', fontSize: '0.9rem' }}>
        &copy; {new Date().getFullYear()} AWS Storage Demo &mdash; Inspired by AWS &mdash; Created by JP Castel
      </footer>
    </div>
  );
}

export default App;
